import React, { useContext } from "react";
import { ThemeProvider } from "styled-components";
import { AssetContext } from "./asset";
import { defaultTheme, swissTheme } from "../theme";

const DynamicThemeProvider = ({ children }) => {
  // Choose theme based on asset context.
  const { isSwissPost } = useContext(AssetContext);
  const selectedTheme = isSwissPost ? swissTheme : defaultTheme;

  return <ThemeProvider theme={selectedTheme}>{children}</ThemeProvider>;
};

export default DynamicThemeProvider;
